import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const Channels = React.lazy(() => import("@mediaspace/features/channels/Channels"));

export const render = getDsLayoutComponentRenderer(Channels);
